import { render, staticRenderFns } from "./ForeignPortsReference.vue?vue&type=template&id=33fe115c&"
import script from "./ForeignPortsReference.vue?vue&type=script&lang=js&"
export * from "./ForeignPortsReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports